import { Anchor, Button, Flex, useMantineTheme } from "@mantine/core";
import {
  BrokersCards,
  HeaderItem,
  Instruments,
  ModalActions,
  ModalVideo,
} from "../../../../../components";
import { client_selected } from "../../../../../client";
import { IMyPlans } from "../../../../../interfaces/MyPlans/IMyPlans";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Youtube } from "iconsax-react";
import { useTermsByLanguage } from "../../../../../utils/GetTerms";

interface IProps {
  product: IMyPlans;
}

type IModalCourse = {
  title: string;
  link: string;
};

const InfosDashboard = ({ product }: IProps) => {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const termsLink = useTermsByLanguage();
  const organizations = product?.product?.organizations;
  const name = client_selected.name;
  const [openModalActions, setOpenModalActions] = useState(false);
  const [openModalCourse, setOpenModalCourse] = useState<IModalCourse>(
    {} as IModalCourse
  );
  const handleOpenModalCourse = (data: IModalCourse) => {
    setOpenModalActions(false);
    setOpenModalCourse(data);
  };

  return (
    <Flex w={"100%"} gap={{ base: 24 }} direction="column">
      <Flex
        align={{ base: "start", 1200: "center" }}
        gap="24px"
        justify={"space-between"}
        w="100%"
        wrap={{ base: "wrap", 1200: "nowrap" }}
      >
        <HeaderItem
          avatar={product?.product?.icon}
          name={product?.seller?.name || name}
          title={product?.product?.title || name}
          backgroundName="basic.1"
          colorWhite
          subtitle={
            !!product?.product?.analyst_certificate_nr
              ? `CNPI ${product?.product?.analyst_certificate_nr}`
              : ""
          }
          category={product?.product?.category}
          subcategory={product?.product?.subcategory}
        />
        <Flex
          gap="8px"
          direction={"column"}
          w={{ base: "100%", 991: "fit-content" }}
        >
          {!!!product?.product?.link_course_app &&
          !!!product?.product?.link_course_money ? null : (
            <Button
              variant={"secondary"}
              miw="225px"
              w={{ base: "100%", 991: "225px" }}
              maw="100%"
              onClick={() => setOpenModalActions(true)}
            >
              {t(
                "meu_portfolio.minhas_compras.card_product.button_access_course"
              )}
            </Button>
          )}
          <Button
            variant={"secondaryTransparent"}
            miw="225px"
            maw="100%"
            w={{ base: "100%", 991: "225px" }}
            href={product?.product?.term_of_contract || termsLink}
            target="_blank"
            component={"a"}
            style={{
              textDecoration: "underline",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {t("meu_portfolio.minhas_compras.card_product.button_view_terms")}
          </Button>
        </Flex>
      </Flex>
      <Instruments
        instruments={product?.product?.instruments?.symbols}
        hasColor={false}
        idProduct={product?.product?.id}
        isCripto={product?.product?.market === "CRIPTO"}
      />
      {!!organizations ? (
        <BrokersCards organizations={organizations} hasColor={false} />
      ) : null}

      <ModalActions
        title={t(
          "meu_portfolio.minhas_compras.card_product.modal_course.title"
        )}
        setClose={() => setOpenModalActions(false)}
        open={openModalActions}
      >
        <>
          {!!product?.product?.link_course_app ? (
            <Button
              variant={"primary"}
              miw="225px"
              w={"100%"}
              onClick={() =>
                handleOpenModalCourse({
                  title: t(
                    "meu_portfolio.minhas_compras.card_product.modal_course.option_one"
                  ),
                  link: product?.product?.link_course_app,
                })
              }
              leftIcon={<Youtube size="32" color={theme.colors.basic[0]} />}
            >
              {t(
                "meu_portfolio.minhas_compras.card_product.modal_course.option_one"
              )}
            </Button>
          ) : null}
          {!!product?.product?.link_course_money ? (
            <Button
              type="button"
              variant={"primary"}
              miw="225px"
              w={"100%"}
              onClick={() =>
                handleOpenModalCourse({
                  title: t(
                    "meu_portfolio.minhas_compras.card_product.modal_course.option_two"
                  ),
                  link: product?.product?.link_course_money,
                })
              }
              leftIcon={<Youtube size="32" color={theme.colors.basic[0]} />}
            >
              {t(
                "meu_portfolio.minhas_compras.card_product.modal_course.option_two"
              )}
            </Button>
          ) : null}
        </>
      </ModalActions>
      <ModalVideo
        title={openModalCourse.title}
        setClose={() => setOpenModalCourse({} as IModalCourse)}
        open={!!openModalCourse.link}
      >
        <iframe
          width="100%"
          height="100%"
          src={openModalCourse.link}
          title={openModalCourse.title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          frameBorder={"0"}
        />
      </ModalVideo>
    </Flex>
  );
};
export default InfosDashboard;
